






















import { Component, Vue } from "vue-property-decorator";
import KeywordSelector from "@/components/KeywordSelector.vue";
import {
  CategorySelectorRow,
  CategoryViewDataRow,
  KeywordSearchResult
} from "@/services/CategoriesDataService";

@Component({
  components: {
    KeywordSelector
  }
})
export default class KeywordExplorer extends Vue {
  handleSelectKeyword(search: string, match: KeywordSearchResult) {
    const selected = {
      field: match.keyword,
      id: match.thesaurusId,
      generic: match.generic
    };
    this.$router.push({
      name: "Keyword Comparison",
      query: {
        payload: JSON.stringify({
          ids: [selected]
        })
      }
    });
  }

  handleSelectCategory(
    category: CategorySelectorRow,
    subcategory: CategoryViewDataRow | null
  ) {
    const param: { [k: string]: string } = {
      id: category.section_letter
    };
    if (subcategory?.id) {
      param.sid = subcategory?.id;
    }
    this.$router.push({
      name: "Category Keywords",
      params: param
    });
  }
}
